export default __webpack_public_path__ + "static/media/graph-1.7aea7510.png";